import classNames from "classnames"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { InputTextarea } from "primereact/inputtextarea"
import React, { useState } from "react"
import { FaArrowLeft, FaTimes } from "react-icons/fa"

function RejectPropostaDialog({ close, reject }) {
  const [mensagem, setMensagem] = useState('')

  const footer = (
    <div className="flex justify-center gap-2 w-full">
      <Button
        label={'Rejeitar'}
        icon={<FaTimes className="mr-2" />}
        severity="danger"
        onClick={() => reject(mensagem)}
      />
      <Button
        label="Voltar"
        icon={<FaArrowLeft className="mr-2" />}
        severity="info"
        onClick={() => close()}
      />
    </div>
  )

  return (
    <Dialog
      visible
      onHide={() => close()}
      header="Rejeitar Proposta"
      footer={footer}
      pt={{
        root: 'max-w-screen lg:max-h-[80vh]',
        headerTitle: 'font-bold text-xl w-full text-center',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            //'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
    >
      <div className="text-center grid">
        <h5>Escreva uma mensagem ao devedor sobre o motivo da rejeição</h5>
        <div className="grid w-full mt-4">
          <InputTextarea
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
          />
        </div>
      </div>
    </Dialog>
  )
}

export default RejectPropostaDialog